"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var date_fns_1 = require("date-fns");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var utilities_2 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var ContentContext_1 = tslib_1.__importDefault(require("../../../common/ContentContext"));
var styled_components_2 = require("../../../theme/styled-components");
var utilities_3 = require("../RaceMatchesList/utilities");
var MatchWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n  ", "\n"], ["\n  padding: ", ";\n  ",
    "\n"])), polished_1.rem(8), function (_a) {
    var isLive = _a.isLive;
    return isLive && styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), function (_a) {
        var theme = _a.theme;
        return theme.color.danger;
    });
});
var LiveIndicator = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  :before {\n    content: '';\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    display: inline-block;\n    border-radius: 100%;\n    margin-right: ", ";\n  }\n"], ["\n  color: ", ";\n  :before {\n    content: '';\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    display: inline-block;\n    border-radius: 100%;\n    margin-right: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.danger;
}, polished_1.rem(8), polished_1.rem(8), function (_a) {
    var theme = _a.theme;
    return theme.color.danger;
}, polished_1.rem(8));
var Row = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n"])));
var StrechWidthScore = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n"])), utilities_1.mb('m'));
var Label = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n  font-size: ", ";\n  font-weight: 600;\n  margin-bottom: ", ";\n  ", "\n"], ["\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n  font-size: ", ";\n  font-weight: 600;\n  margin-bottom: ", ";\n  ",
    "\n"])), utilities_1.mb('m'), polished_1.rem(14), polished_1.rem(16), function (_a) {
    var center = _a.center;
    return !!center && styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      ", " {\n        justify-content: center;\n      }\n    "], ["\n      ", " {\n        justify-content: center;\n      }\n    "])), LiveIndicator);
});
var MatchStatus = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n  margin-top: ", ";\n  font-size: ", ";\n"], ["\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n  margin-top: ", ";\n  font-size: ", ";\n"])), utilities_1.mb('m'), polished_1.rem(16), polished_1.rem(14));
var Winner = styled_components_1["default"].div(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject([""], [""])));
var SportGroundAdditionalProperties = styled_components_1["default"].div(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  font-size: ", ";\n  align-items: center;\n  img {\n    width: ", ";\n    margin-right: ", ";\n  }\n  > *:not(:last-child):after {\n    content: '';\n    border-right: ", " solid ", ";\n    height: 100%;\n    margin-right: ", ";\n    margin-left: ", ";\n  }\n"], ["\n  display: flex;\n  font-size: ", ";\n  align-items: center;\n  img {\n    width: ", ";\n    margin-right: ", ";\n  }\n  > *:not(:last-child):after {\n    content: '';\n    border-right: ", " solid ", ";\n    height: 100%;\n    margin-right: ", ";\n    margin-left: ", ";\n  }\n"])), polished_1.rem(13), polished_1.rem(16), polished_1.rem(8), polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, polished_1.rem(8), polished_1.rem(8));
var MatchPreview = function (_a) {
    var _b;
    var match = _a.match, _c = _a.view, view = _c === void 0 ? 'full' : _c, showCompetitionName = _a.showCompetitionName;
    var context = React.useContext(ContentContext_1["default"]);
    var getTeamNameFunc = utilities_2.getProp(context, ['helpers', 'getTeamName'], utilities_3.getTeamName);
    var translateSportGroundAdditionalProperties = utilities_2.getProp(context, [
        'helpers',
        'translateSportGroundAdditionalProperties',
    ]);
    var renderMatchStatus = function () {
        if (match.contumation && match.contumation.isContumated) {
            return 'Kontumované';
        }
        else if (match.closed || getWinner()) {
            return 'Koniec';
        }
        else if (!match.closed &&
            match.startDate &&
            date_fns_1.isSameDay(new Date(), new Date(match.startDate)) &&
            date_fns_1.isAfter(new Date(), new Date(match.startDate))) {
            return React.createElement(LiveIndicator, null, "Live");
        }
        else if (!match.closed) {
            return '';
        }
        else {
            return React.createElement(LiveIndicator, null, "Live");
        }
    };
    var getWinner = function () {
        var sortedResults = utilities_2.getProp(match, ['protocol', 'results'], [])
            .filter(function (i) { return (i.points || []).length; })
            .sort(function (a, b) {
            var aIndividualResult = (a.points || []).find(function (point) { return point && point.name === 'individual'; });
            var bIndividualResult = (b.points || []).find(function (point) { return point && point.name === 'individual'; });
            if (aIndividualResult &&
                bIndividualResult &&
                aIndividualResult.value &&
                bIndividualResult.value &&
                Number(aIndividualResult.value) < Number(bIndividualResult.value)) {
                return -1;
            }
            else if (aIndividualResult &&
                bIndividualResult &&
                aIndividualResult.value &&
                bIndividualResult.value &&
                Number(aIndividualResult.value) > Number(bIndividualResult.value)) {
                return 1;
            }
            else if ((!aIndividualResult || !aIndividualResult.value) &&
                bIndividualResult &&
                bIndividualResult.value) {
                return 1;
            }
            else if (aIndividualResult &&
                aIndividualResult.value &&
                (!bIndividualResult || !bIndividualResult.value)) {
                return -1;
            }
            else {
                var aTimeResult = (a.points || []).find(function (point) { return point && point.name === 'time'; });
                var bTimeResult = (b.points || []).find(function (point) { return point && point.name === 'time'; });
                if (aTimeResult &&
                    bTimeResult &&
                    aTimeResult.value < bTimeResult.value) {
                    return -1;
                }
                else if (aTimeResult &&
                    bTimeResult &&
                    aTimeResult.value > bTimeResult.value) {
                    return 1;
                }
                else {
                    var aPointsResult = (a.points || []).find(function (point) { return point && point.name === 'points'; });
                    var bPointsResult = (b.points || []).find(function (point) { return point && point.name === 'points'; });
                    if (aPointsResult &&
                        bPointsResult &&
                        aPointsResult.value < bPointsResult.value) {
                        return 1;
                    }
                    else if (aPointsResult &&
                        bPointsResult &&
                        aPointsResult.value > bPointsResult.value) {
                        return -1;
                    }
                    return 0;
                }
            }
        });
        return sortedResults[0];
    };
    var dateFormat = 'dd.MM.yyyy';
    var winner = null;
    var winnerTeam = null;
    try {
        var winnerObject = getWinner();
        winner = {
            label: "" + winnerObject.players.map(function (p) { return p.name; }).join(', '),
            teamId: winnerObject.teamId
        };
        var winnerTeamObject = match.teams.find(function (team) { return team._id === (winner === null || winner === void 0 ? void 0 : winner.teamId); });
        winnerTeam = {
            label: getTeamNameFunc(match.appSpace, winnerTeamObject),
            detailUrl: winnerTeamObject === null || winnerTeamObject === void 0 ? void 0 : winnerTeamObject.detailUrl
        };
    }
    catch (e) {
        //
    }
    if (view === 'full') {
        var matchStatus = renderMatchStatus();
        return (React.createElement(MatchWrapper, null,
            React.createElement(Row, null,
                React.createElement(Label, null,
                    !!showCompetitionName && match.competition.name,
                    ' ',
                    match.startDate ? (React.createElement("span", null,
                        date_fns_1.format(new Date(match.startDate), dateFormat),
                        "\u00A0",
                        date_fns_1.format(new Date(match.startDate), 'HH:mm'))) : ('')),
                React.createElement(StrechWidthScore, null,
                    React.createElement("div", null,
                        React.createElement("b", null, (_b = match.round) === null || _b === void 0 ? void 0 : _b.name),
                        React.createElement("br", null),
                        match.perex && (React.createElement("span", { style: { fontSize: polished_1.rem(13) } }, "" + match.perex)),
                        match.sportGround && (React.createElement(React.Fragment, null,
                            React.createElement("span", { style: { fontSize: polished_1.rem(13) } }, "" + (match.sportGround
                                .displayName || match.sportGround.sportObjectName)),
                            Object.keys(match.sportGround.additionalData || {}).length >
                                0 && (React.createElement(React.Fragment, null,
                                React.createElement(SportGroundAdditionalProperties, null, translateSportGroundAdditionalProperties &&
                                    translateSportGroundAdditionalProperties(match.sportGround.additionalData || {}).map(function (prop) {
                                        var content = [];
                                        if (prop.src) {
                                            content = tslib_1.__spreadArrays(content, [
                                                React.createElement("img", { alt: "sport-ground-additional-data", src: prop.src }),
                                            ]);
                                        }
                                        if (prop.label) {
                                            content = tslib_1.__spreadArrays(content, [React.createElement("div", null, prop.label)]);
                                        }
                                        return content;
                                    })))))))),
                (winner || matchStatus) && (React.createElement(MatchStatus, null, winner ? (React.createElement(Winner, null,
                    React.createElement("div", null,
                        React.createElement("b", { style: { fontWeight: 800, fontSize: polished_1.rem(14) } }, winner.label)),
                    React.createElement("div", null, winnerTeam === null || winnerTeam === void 0 ? void 0 : winnerTeam.label))) : (matchStatus))))));
    }
    return null;
};
exports["default"] = styled_components_2.withTheme(MatchPreview);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
